import {Social} from "./social/Social";

export const Banner = () => {
    return (
        <div className="banner__container">
            <video autoPlay={true} muted={true} loop={true} playsInline={true} id={'banner__background'}>
                <source src={'/assets/videos/waves.mp4'} type={'video/mp4'}/>
            </video>
            <h2>"SOMOS CALIDAD Y GARANTÍA"</h2>
            <p></p>
            <small>Seguinos en:</small>
            <div className="social__container">
                <Social
                    icon="akar-icons:instagram-fill"
                    title="Instagram"
                    link="https://www.instagram.com/dentpiletas/"
                />
                <Social
                    icon="icon-park-outline:facebook"
                    title="Facebook"
                    link="https://www.facebook.com/dentpiletasmoreno"
                />
            </div>
        </div>
    )
}
